import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

/** Accessible FAQ accordion. `faqs`: [{ question, answer }] */
export function FaqAccordion({ faqs }) {
  const [openIndex, setOpenIndex] = useState(0);
  if (!faqs || faqs.length === 0) return null;
  return (
    <div className="max-w-2xl mx-auto divide-y divide-white/10 border border-white/10 rounded-2xl overflow-hidden" data-testid="faq-accordion">
      {faqs.map((f, i) => {
        const isOpen = openIndex === i;
        return (
          <div key={f.question}>
            <button
              onClick={() => setOpenIndex(isOpen ? -1 : i)}
              data-testid={`faq-question-${i}`}
              className="w-full flex items-center justify-between gap-3 px-5 py-4 text-left text-[14.5px] font-semibold text-white hover:bg-white/5 transition-colors"
            >
              {f.question}
              <ChevronDown className={`h-4 w-4 shrink-0 text-slate-400 transition-transform ${isOpen ? "rotate-180" : ""}`} />
            </button>
            {isOpen && (
              <div className="px-5 pb-4 text-[13.5px] text-slate-400 leading-relaxed" data-testid={`faq-answer-${i}`}>
                {f.answer}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
